// extracted by mini-css-extract-plugin
module.exports = {"item":"ProductCategories_item__dmYhQ","section":"ProductCategories_section__3drU_"};